module.exports = __webpack_public_path__ + "static/media/safehouse.21412c6e.png";